import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';

import { PagedResponse } from '../../shared/models/paged-response';
import { SingleResponse } from '../../shared/models/single-response';

import { BaseService } from '../../shared/base.service';
import { NocontentResponse } from '../../shared/models/nocontent-response';
import { ActualAddressPagedParameter } from '../models/actual-address.parameter';
import { ActualAddressListModel } from '../models/actual-address-list.model';
import { ActualAddressDetailsModel } from '../models/actual-address-details.model';
import { ActualAddressModel } from '../models/actual-address.model';
import { ListResponse } from 'src/app/shared/models/list-response';

@Injectable({
  providedIn: 'root'
})
export class ActualaddressService extends BaseService {

  private apiUrl = `${this.apiUrlBase}/api/actualaddress`;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  /**
   * 获取分页列表
   * @param parameter 查询参数
   */
  paged(parameter: ActualAddressPagedParameter): Observable<PagedResponse<ActualAddressListModel>> {
    // 参数处理
    const params = this.removeEmptyProps(parameter);
    return this.http.get<PagedResponse<ActualAddressListModel>>(this.apiUrl, { params });
  }

  /**
   * 获取所有角色列表
   */
  getAll(): Observable<ListResponse<ActualAddressListModel>> {
    const url = `${this.apiUrl}/list`;
    return this.http.get<ListResponse<ActualAddressListModel>>(url);
  }

  /**
   * 获取详情
   * @param id ID
   */
  details(id?: string): Observable<PagedResponse<ActualAddressDetailsModel>> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<PagedResponse<ActualAddressDetailsModel>>(url);
  }

  /**
   * 新增
   * @param model 设备
   */
  add(model?: ActualAddressModel): Observable<SingleResponse<number>> {
    const url = `${this.apiUrl}`;

    return this.http.post<SingleResponse<number>>(url, model, this.httpOptions);
  }

  /**
   * 更新
   * @param model 设备
   */
  update(model?: ActualAddressModel): Observable<SingleResponse<number>> {
    const url = `${this.apiUrl}/${model.id}`;

    return this.http.put<SingleResponse<number>>(url, model, this.httpOptions);
  }

  /**
   * 撤销删除
   * @param id ID
   */
  undelete(id: string): Observable<NocontentResponse> {
    const url = `${this.apiUrl}/undelete/${id}`;
    return this.http.delete<NocontentResponse>(url, this.httpOptions);
  }

  /**
   * 删除
   * @param id ID
   */
  delete(id: string): Observable<NocontentResponse> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.delete<NocontentResponse>(url, this.httpOptions);
  }
}

